import React from 'react';
import { cx } from 'linaria';
import { jcm } from 'utils';
import { Typography } from 'fronton-react';
import { styles } from './styles';
import { ProductBestPriceNameplate } from './product-best-price-nameplate';
import { getFormattedOldPrice, getFormattedPrice, getNumericFract } from './utils';
import { SubtitleView } from './subtitle-view';
import { ProductPriceViewProps } from './types';
import { ProductDiscountPercent } from './product-discount-percent';

export const DATA_QA_PRICE_VIEW = 'price-view';

export const ProductPriceView: React.FC<ProductPriceViewProps> = ({
  currency,
  fract,
  intPart,
  prevPrice,
  slot,
  unit,
  variant = 'primary-price',
  isBestPrice,
  className = '',
  seoMeta,
  discountPercent,
  ...htmlProps
}) => {
  const hasOldPrice = variant === 'old-new-price';

  if (hasOldPrice || isBestPrice) {
    return (
      <div data-qa="price-view" className={className}>
        {isBestPrice ? (
          <ProductBestPriceNameplate />
        ) : (
          <div className={styles.oldPriceWrapper}>
            <ProductDiscountPercent percent={discountPercent} />

            <div className={styles.oldPriceCrossed}>
              <Typography variant="s" size="body_accent" color="text-primary">
                {getFormattedOldPrice(prevPrice)}
              </Typography>
              <Typography
                variant="s"
                size="body_accent"
                color="text-primary"
                className={styles.oldCurrencyWrap}
              >
                {currency}
              </Typography>
            </div>
          </div>
        )}

        <div
          className={
            isBestPrice ? cx(styles.newPriceContainer, styles.textPrimaryStyle) : styles.newPriceContainer
          }
        >
          <span className={styles.newPriceMainWrap}>
            {getFormattedPrice(intPart) + (getNumericFract(fract) ? ',' : '')}
          </span>
          {getNumericFract(fract) > 0 && <span className={styles.newPriceFractWrap}>{fract}</span>}
          <span className={cx(styles.newCurrencyWrap)}>{`${currency}${unit ? `/${unit}` : ''}`}</span>
        </div>

        {isBestPrice && hasOldPrice && (
          <div className={styles.oldPriceCrossed}>
            <Typography variant="m" size="body_accent" color="text-primary">
              {getFormattedOldPrice(prevPrice)}
            </Typography>
            <Typography
              variant="s"
              size="body_accent"
              color="text-primary"
              className={styles.oldCurrencyWrap}
            >
              {currency}
            </Typography>
          </div>
        )}
      </div>
    );
  }
  return (
    <div
      data-qa={DATA_QA_PRICE_VIEW}
      className={jcm({
        [className]: true,
        [styles.primaryPriceView]: variant === 'primary-price',
        [styles.secondPriceView]: variant === 'second-price',
        [styles.subtitleView]: variant === 'subtitle',
      })}
      {...htmlProps}
    >
      {variant !== 'subtitle' && (
        <>
          {getFormattedPrice(intPart)}
          {getNumericFract(fract) > 0 && (
            <>
              <span className={styles.comma}>,</span>
              {fract}
            </>
          )}

          <span
            className={jcm({
              [styles.signaturePrimary]: variant === 'primary-price',
              [styles.signatureSecondary]: variant === 'second-price',
            })}
          >
            {currency}
            {unit && (
              <>
                <span>/</span>
                {unit}
              </>
            )}
          </span>
        </>
      )}
      {variant === 'subtitle' && (
        <SubtitleView
          fract={fract}
          currency={currency}
          unit={unit}
          intPart={intPart}
          prevPrice={prevPrice}
        />
      )}
      {seoMeta}
    </div>
  );
};
